import {AuthGuard} from '../../shared/guards/AuthGuard';
import {SinisterDetailsPresentation} from './components';
import {Sidebar} from '../../shared/components';

export const SinisterDetailsPage = (): JSX.Element => {
    return (
        <AuthGuard>
            <Sidebar>
                <SinisterDetailsPresentation/>
            </Sidebar>
        </AuthGuard>
    )
};